module.exports = __webpack_public_path__ + "img/app-store.17edad80.svg";